export const INVISIBLE_SEPARATOR_CHARACTER = '\u200B';

/**
 * Matches a mentioning template that
 * has an extra display value added on the end
 * e.g. {@|12345|user}[<Giancarlo Galliani>]
 *
 * The first part (i.e. {@|12345|user})
 * is captured so it can be returned in a replace function
 */
export const mentionWithExtraTemplate = () =>
  new RegExp('({.+?})\\[<.+?>\\]', 'g');

/**
 * We use this regex to split the comment text by mentions and non mentions.
 * Note that we cannot include the non capturing check for spaces here as
 * above as that results in the space not being included in the split.
 * Explanation of the parts:
 *
 * \u2063 (Legacy) or \200B - Invisible characters that surrounds a completed mention. This
 * regex is only used for completed mentions so it's an easy way to select
 * mentions from the rest of the text.
 *
 * @[^${INVISIBLE_SEPARATOR_CHARACTER}]+ "@" and one or more of any
 * character that isn't the invisible separator character. Allows names
 * in any script to be identified.
 *
 */
export const mentionWithNoPrecedingSpace = () =>
  new RegExp(
    `(${INVISIBLE_SEPARATOR_CHARACTER}@[^${INVISIBLE_SEPARATOR_CHARACTER}]+${INVISIBLE_SEPARATOR_CHARACTER})`,
    'g'
  );

/**
 * Extract the mentioned user's name from the following
 * template: {@|3|user}[<John Citizen>]
 * We still need to ensure this is a valid mention by matching the complete
 * template but only capture the section we are after.
 */
export const getMentionName = () =>
  new RegExp('{@\\|\\d+\\|user}\\[<(.+?)>\\]', 'g');

/**
 * Matches a mentioning template that
 * has an extra display value added on the end
 * e.g. {@|12345|user}[<John Citizen>]
 *
 * NOTE:
 * This is similar to mentionWithExtraTemplate except
 * here we capture the whole template and not just a subsection of it
 */
export const mentionWithValidTemplate = () =>
  new RegExp('({@\\|\\d+\\|user}\\[<.+?>\\])', 'g');

export const invisibleSeparator = () =>
  new RegExp(INVISIBLE_SEPARATOR_CHARACTER, 'g');
